import "./App.css";
import Fibonacci from "./Fibonacci";
import OptionsPrice from "./OptionsPrice";
import { BrowserRouter, Routes, Route } from "react-router-dom";


import PivotPointscal from "./Pivotpointscalculator";

function App() {
  return (
    <div className="outerdiv flex justify-center">
      <BrowserRouter>
      <Routes>
        <Route path="/Fibonacci" element={<Fibonacci />}/>
  
        <Route path="/PivotPointscal" element={<PivotPointscal/>}/>
          <Route path="/OptionsPrice" element={<OptionsPrice/>}/>
      </Routes>
    </BrowserRouter>
    </div>
  );
}

export default App;
